import { Component, input, output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { WorkflowComment } from '#models';

@Component({
  selector: 'app-detail-comments',
  imports: [DatePipe],
  templateUrl: './detail-comments.component.html',
  styleUrl: './detail-comments.component.scss',
})
export class DetailCommentsComponent {
  comments = input<WorkflowComment[]>([]);
  open = input<boolean>(false);
  draft = input<string>('');
  posting = input<boolean>(false);

  toggled = output<void>();
  draftChanged = output<string>();
  posted = output<void>();

  private readonly _avatarColors = ['#1f6f8b', '#6d4bb3', '#8a5a1f', '#2f7d4f', '#9c4a5f', '#3a6ea5'];

  onToggle(): void {
    this.toggled.emit();
  }

  onDraftInput(value: string): void {
    this.draftChanged.emit(value);
  }

  onPost(): void {
    if (!this.draft().trim() || this.posting()) {
      return;
    }
    this.posted.emit();
  }

  getInitials(author: string): string {
    const parts = (author ?? '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) {
      return '?';
    }
    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  getAvatarColor(author: string): string {
    const key = author ?? '';
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
    }
    return this._avatarColors[hash % this._avatarColors.length];
  }

  getRelativeTime(value: string): string {
    const timestamp = Date.parse(value);
    if (Number.isNaN(timestamp)) {
      return '';
    }
    const minutes = Math.floor((Date.now() - timestamp) / 60000);
    if (minutes < 1) {
      return 'just now';
    }
    if (minutes < 60) {
      return `${minutes}m ago`;
    }
    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
      return `${hours}h ago`;
    }
    const days = Math.floor(hours / 24);
    if (days < 7) {
      return `${days}d ago`;
    }
    const weeks = Math.floor(days / 7);
    if (weeks < 5) {
      return `${weeks}w ago`;
    }
    const months = Math.floor(days / 30);
    if (months < 12) {
      return `${months}mo ago`;
    }
    return `${Math.floor(days / 365)}y ago`;
  }
}
